/**
 * Qatar History Persona - Avatar Prompts (Arabic)
 *
 * Arabic translations of scripts/prompts for what the avatar says during each module.
 */

export const modulePrompts = {
  'geography-intro': `مرحباً!   أنا نيكس. أنا هنا لمساعدتك في تعلم تاريخ قطر.

لفهم تاريخ قطر، يجب أن نبدأ بجغرافيتها.

قطر شبه جزيرة صغيرة تمتد في الخليج العربي.   الأرض في الغالب مسطحة وصحراوية،   مع أمطار قليلة جداً ولا أنهار رئيسية.

ولهذا السبب، كان الزراعة صعبة للمستوطنين الأوائل.   بدلاً من ذلك، اعتمد الناس على البحر للبقاء.   وفر الخليج الأسماك للطعام   وطرق بحرية للسفر والتجارة.

مع مرور الوقت، ساعد موقع قطر على ربطها بالمناطق القريبة   مثل الجزيرة العربية وبلاد فارس والهند وشرق أفريقيا.

على الرغم من قسوة البيئة،   وضعت الجغرافيا قطر بهدوء في مركز التبادل الإقليمي.

هل أنت مستعد لاختبار معرفتك؟   قل "متابعة" عندما تكون جاهزاً للاختبار.`,

  'quiz-geography': `ممتاز!   لنجرب فهمك لجغرافية قطر.

سأطرح عليك بضعة أسئلة.   يرجى اختيار إجابتك من الخيارات المعروضة على الشاشة.`,

  'pearl-diving-pdf': `الآن لننظر إلى تراث صيد اللؤلؤ في قطر.

سأعرض عليك نظرة مرئية على هذه الحقبة المهمة في تاريخ قطر.`,

  'pearl-diving-intro': `قبل النفط والغاز، كان البحر العمود الفقري لاقتصاد قطر.

لأجيال عديدة، وفر صيد اللؤلؤ الدخل للمجتمعات الساحلية.   قضى الغواصون ساعات طويلة في البحر،   يغوصون مراراً في أعماق المياه دون معدات أوكسجين لجلب اللآلئ.

كانت هذه اللآلئ ثمينة   وتُتاجر بها مع تجار من الهند وأوروبا.

كانت الحياة خلال حقبة صيد اللؤلؤ صعبة وغير مؤكدة،   حيث كان دخل العائلة يعتمد على نجاح كل موسم.

في أوائل القرن العشرين،   أدى ظهور اللآلئ المستزرعة إلى انخفاض حاد في الطلب العالمي على اللآلئ الطبيعية.   أجبر هذا التغيير المفاجئ قطر على البحث عن فرص اقتصادية جديدة.

هل أنت مستعد لاختبار معرفتك؟   قل "متابعة" عندما تكون جاهزاً للاختبار.`,

  'quiz-pearl-diving': `لنجرب فهمك لاقتصاد صيد اللؤلؤ.

سأطرح عليك بضعة أسئلة.   يرجى اختيار إجابتك من الخيارات المعروضة على الشاشة.`,

  'leadership-intro': `مع زيادة التجارة والمنافسة الإقليمية،   احتاجت قطر إلى قيادة سياسية قوية.

خلال القرن التاسع عشر،   برزت عائلة آل ثاني كالعائلة الحاكمة،   ساعدت على توحيد القبائل المحلية والحفاظ على الاستقرار.

في نفس الوقت، وسعت بريطانيا نفوذها في الخليج   لحماية طرق البحر المهمة.

دخلت قطر اتفاقيات مع بريطانيا   وفرت الحماية من التهديدات الخارجية   مع السماح للحكام المحليين بإدارة الشؤون الداخلية.

ساعد هذا التوازن قطر على البقاء مستقرة   خلال فترة من عدم اليقين الإقليمي   وسمح لقيادتها بتعزيز السيطرة على البلاد.

هل أنت مستعد لاختبار معرفتك؟   قل "متابعة" عندما تكون جاهزاً للاختبار.`,

  'quiz-leadership': `لنجرب فهمك للحكم والاستقرار.

سأطرح عليك بضعة أسئلة.   يرجى اختيار إجابتك من الخيارات المعروضة على الشاشة.`,

  'independence-intro': `بحلول منتصف القرن العشرين،   بدأت بريطانيا في تقليل حضورها في الخليج.

أوجد هذا لحظة مهمة لقطر.   اختارت البلاد أن تصبح مستقلة بالكامل   بدلاً من الانضمام إلى اتحاد سياسي أكبر.

في عام 1971، أعلنت قطر رسمياً استقلالها   وأصبحت دولة ذات سيادة،   مما يعني أنها حصلت على السيطرة الكاملة على حكومتها وعلاقاتها الخارجية.

ميز الاستقلال بداية مرحلة جديدة،   حيث بدأت قطر في بناء المؤسسات الحديثة،   وتعزيز الهوية الوطنية،   وأخذ مكانها في المجتمع الدولي.

هل أنت مستعد لاختبار معرفتك؟   قل "متابعة" عندما تكون جاهزاً للاختبار.`,

  'quiz-independence': `لنجرب معرفتك باستقلال قطر.

سأطرح عليك بضعة أسئلة.   يرجى اختيار إجابتك من الخيارات المعروضة على الشاشة.`,

  'oil-gas-pdf': `الآن لننظر إلى كيفية تحويل النفط والغاز لقطر.

سأعرض عليك نظرة مرئية على تنمية الطاقة في قطر.`,

  'oil-gas-intro': `أدى اكتشاف النفط والغاز الطبيعي   إلى تحويل قطر أسرع من أي بلد تقريباً في التاريخ.

اكتُشف النفط في الأربعينيات،   ولاحقاً وُجدت احتياطيات ضخمة من الغاز الطبيعي في الحقل الشمالي.

جلب هذه الموارد ثروة كبيرة   وسمح لقطر بالاستثمار بشكل كبير في البنية التحتية والتعليم والرعاية الصحية.

توسعت المدن، وتحسنت مستويات المعيشة،   وظهرت فرص جديدة.

بدلاً من الاعتماد فقط على الموارد الطبيعية،   ركزت قطر على التنمية طويلة الأجل   والتخطيط للمستقبل.

هل أنت مستعد لاختبار معرفتك؟   قل "متابعة" عندما تكون جاهزاً للاختبار.`,

  'quiz-oil-gas': `لنجرب معرفتك بقطاع الطاقة في قطر.

سأطرح عليك بضعة أسئلة.   يرجى اختيار إجابتك من الخيارات المعروضة على الشاشة.`,

  'modern-qatar-intro': `اليوم، قطر أمة حديثة   تواصل تقدير تقاليدها.

بينما تبنت البلاد التجارة العالمية والتعليم والتكنولوجيا والدبلوماسية،   فهي أيضاً تحافظ على الممارسات الثقافية والدينية.

تلعب قطر دوراً نشطاً في الشؤون الدولية   وتستضيف أحداثاً عالمية كبرى.

يأتي نفوذها من التخطيط الدقيق،   وقيادة الطاقة،   وشعور قوي بالهوية الوطنية   بدلاً من الحجم أو عدد السكان.

هل أنت مستعد لاختبار معرفتك؟   قل "متابعة" عندما تكون جاهزاً للاختبار النهائي.`,

  'quiz-modern-qatar': `لنجرب فهمك لقطر الحديثة.

سأطرح عليك بضعة أسئلة.   يرجى اختيار إجابتك من الخيارات المعروضة على الشاشة.`,
};

export const moduleTransitionPrompts = {
  'quiz-geography': `عمل رائع!   أنت الآن تفهم جغرافية قطر وكيف شكلت الحياة المبكرة.

بعد ذلك، سنستكشف حقبة صيد اللؤلؤ   وأهميتها لاقتصاد قطر المبكر.

قل "متابعة" عندما تكون جاهزاً للمتابعة.`,

  'quiz-pearl-diving': `ممتاز!   أنت الآن تفهم اقتصاد صيد اللؤلؤ   وتحدياته.

بعد ذلك، سننظر إلى القيادة السياسية   وعلاقة قطر مع بريطانيا.

قل "متابعة" عندما تكون جاهزاً.`,

  'quiz-leadership': `أحسنت!   أنت الآن تفهم كيف شكلت عائلة آل ثاني   والاتفاقيات البريطانية حكم قطر.

بعد ذلك، سنستكشف مسار قطر نحو الاستقلال.

قل "متابعة" عندما تكون جاهزاً.`,

  'quiz-independence': `عمل عظيم!   أنت الآن تفهم رحلة قطر نحو السيادة في عام 1971.

بعد ذلك، سنرى كيف غيّر النفط والغاز   الأمة.

قل "متابعة" عندما تكون جاهزاً.`,

  'quiz-oil-gas': `ممتاز!   أنت الآن تفهم كيف قادت موارد الطاقة   التنمية السريعة لقطر.

أخيراً، سننظر إلى دور قطر في العالم الحديث.

قل "متابعة" عندما تكون جاهزاً.`,
};

export const videoCompletionPrompts = {
  // No video modules in this course
};

export const courseCompletionPrompt = `تهانينا!   لقد أكملت أساسيات تاريخ قطر.

أنت الآن تفهم كيف شكلت الجغرافيا والقيادة والموارد الطبيعية   رحلة قطر من مجتمع صيد اللؤلؤ   إلى أمة عالمية حديثة.

شكراً لتعلمك معي اليوم!`;

export const welcomeMessage = "مرحباً! أهلاً بك في أساسيات تاريخ قطر. أنا نيكس، مرشدك الذكي. لنستكشف رحلة قطر الرائعة!";

const qatarHistoryPrompts = {
  modulePrompts,
  moduleTransitionPrompts,
  videoCompletionPrompts,
  courseCompletionPrompt,
  welcomeMessage,
};

export default qatarHistoryPrompts;
